import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class StockCardProduct extends Component{
    constructor(){
        super();
        this.save = this.save.bind(this)
        this.state={
            userId : "",
            user : {},
            criteria : {},
            list :{}
        }
        
    }

    componentDidMount(){
        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });

        var data = ref.child("Inventory").child("Products").child(this.props.match.params.id)
            data.on("value", function(snap){
                this.setState({
                    criteria : snap.val()
                })
            }.bind(this))

        var inventory = ref.child("StockCard").child("Products")
            inventory.on("value", function(snap){
                this.setState({
                    list : snap.val()
                })
            }.bind(this))    
    }

    save(e){
        e.preventDefault()
        console.log(this.state.list)
    }
    

    
          
    render() {

        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title=" Stock Card" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" >
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.product_name} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Length</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.product_length} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Color</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.product_color} />
                                        </div>
                                    </div>

                                </form>    
                                <table id="ecom-products" className="table table-bordered table-striped ">
                                    <thead>
                                        <tr>               
                                            <th className="text-center">Date</th>
                                            <th className="text-center">In/Out</th>
                                            <th className="text-center">Count</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   
                                            this.state.list &&
                                            Object.keys(this.state.list).map(key => {
                                                let list = this.state.list[key]
                                                let criteria = this.state.criteria
                                                if (criteria.product_Id === list.product_Id && criteria.product_color === list.product_color && criteria.product_length === list.product_length){
                                                    return (<tr>
                                                                <td>
                                                                    {list.date}
                                                                </td>
                                                                
                                                                <td>
                                                                    {list.status}
                                                                </td>
                                                                <td>
                                                                    {list.product_count}
                                                                </td>

                                                            </tr>) 
                                                }
                                                
                                            })
                                        }
                                        
                                    </tbody>
                                </table>
                                               
                            </div>                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  StockCardProduct;



// WEBPACK FOOTER //
// ./src/components/StockCardProduct.js